export const REGION_US = 'US'
export const REGION_ISO_US = 'en-US'
export const REGION_ISO_GB = 'en-GB'
export const BTN_BOTTOM = 'bot'
export const BTN_TOP = 'top'
export const CUR_EUR = 'EUR'
export const CUR_GBP = 'GBP'
export const CUR_USD = 'USD'
export const CUR_CHF = 'CHF'
export const BTN_DLY = 'dly'
export const BTN_MTD = 'mtd'
export const BTN_QTD = 'qtd'
export const BTN_YTD = 'ytd'
export const BTN_3M = 'mos3RoR'
export const BTN_1Y = 'yr1RoR'
export const BTN_3Y = 'yr3RoR'
export const BTN_5Y = 'yr5RoR'
export const BTN_10Y = 'yr10RoR'
export const YR_01_ROR_NAV = 'yr1RoRNav'
export const YR_03_ROR_NAV = 'yr3RoRNav'
export const YR_05_ROR_NAV = 'yr5RoRNav'
export const YR_10_ROR_NAV = 'yr10RoRNav'



// WEBPACK FOOTER //
// ./src/services/Constants.js